export default {
  selectReminderNotifications: (state) => state.platform.reminderNotifications,

  selectLeadToProposalDrawerVisible: (state) => state.platform.sales.projects.leadToProposalDrawer.isVisible,

  getTeamAddLeadDrawerVisible: (state) => state.platform.sales.team.addLeadDrawerVisible,

  getProfileMentorshipTabVisible: (state) => state.platform.personal.profile.profileMentorshipTabVisible,

  getProfileOrganizationTabVisible: (state) => state.platform.personal.profile.profileOrganizationTabVisible,

  selectLeadToProposalDrawerLeadId: (state) => state.platform.sales.projects.leadToProposalDrawer.leadId,
  selectLeadToProposalDrawerProjectId: (state) => state.platform.sales.projects.leadToProposalDrawer.projectId,
  selectLeadToProposalDrawerProposalType: (state) => state.platform.sales.projects.leadToProposalDrawer.proposalType,
  selectLeadToProposalInitialTab: (state) => state.platform.sales.projects.leadToProposalDrawer.initialTab,
  selectLeadToProposalRequestedProduct: (state) => state.platform.sales.projects.leadToProposalDrawer.requestedProduct,
  selectLeadToProposalBatteryUpsell: (state) => !!state.platform.sales.projects.leadToProposalDrawer.batteryUpsell,
  selectLeadToProposalLeadDetails: (state) => state.platform.sales.projects.leadToProposalDrawer.leadDetails,
  selectLeadToProposalProjectDetails: (state) => state.platform.sales.projects.leadToProposalDrawer.projectDetails,
  selectLeadToProposalUtilities: (state) => state.platform.sales.projects.leadToProposalDrawer.utilityCompanies,
  selectLeadToProposalRequestSubmitted: (state) =>
    state.platform.sales.projects.leadToProposalDrawer.proposalRequestSubmitted,
  selectLeadToProposalRequestDetails: (state) =>
    state.platform.sales.projects.leadToProposalDrawer.proposalRequestDetails,
  selectLeadToProposalLinkedProjectId: (state) => state.platform.sales.projects.leadToProposalDrawer.linkedProjectId,
  selectDuplicateLeadDetails: (state) => state.platform.sales.projects.leadToProposalDrawer.duplicateLeadDetails,

  getOfferLeadConfirmationModalVisible: ({ enterpriseProjects: { offerLeadConfirmation } }) =>
    !!offerLeadConfirmation && !!offerLeadConfirmation.consultant && !!offerLeadConfirmation.terms,

  selectPlatformServices: (state) => state.platform.gettingStarted.services,

  selectInboxNotificationsCount: (state) => state.platform.inbox.inboxNotificationsCount,

  selectcontainerOverFlow: (state) => state.platform.containerOverFlow,

  getInviteDrawerVisible: (state) => state.platform.sales.team.inviteDrawerVisible,

  selectHomeownerNotesDrawerVisible: (state) => state.platform.sales.projects.homeownerNotesDrawerVisible,
  selectHomeownerNotesLeadId: (state) => state.platform.sales.projects.homeownerNotesLeadId,
  selectBannersHeight: (state) => state.platform.bannersHeight,

  selectIntegrityTrainingModalVisible: (state) => state.platform.integrityTrainingModalVisible,

  selectProposalRequestId: (state) => state.platform.sales.projects.proposalRequestId,
  selectProposalRequestProjectId: (state) => state.platform.sales.projects.proposalRequestProjectId,
  selectProposalRequestDrawerDisabled: (state) => state.platform.sales.projects.proposalRequestDrawerDisabled,
  selectProposalRequestType: (state) => state.platform.sales.projects.proposalRequestType,

  selectAlertMessage: (state) => state.platform.alertMessage,

  selectProjectMiniHeaderActive: (state) => state.platform.sales.projects.projectDetailMiniHeaderActive,

  selectProjectClosedBannerActive: (state) => state.platform.sales.projects.projectClosedBannerActive,
  selectIsZendeskChatbotOpen: (state) => state.platform.isZendeskChatbotOpen,
  selectIsZendeskAuthenticated: (state) => state.platform.isZendeskAuthenticated,
};
